import { get, getRequired } from '@excent-one/config';

export const appName = get('VITE_APP_DOCUMENT_TITLE', 'PHRMPC');
export const siteName = get('VITE_APP_SITE_NAME', 'PHRMPC - Manning');
export const appVersion = get('VITE_APP_VERSION', '0.0.0');
// VITE_ARBITR_IAS_* aren't in @excent-one/config's EnvironmentVariable union yet, and that type
// isn't exported publicly to widen locally either. Remove these casts once the package's own
// variable list is updated upstream.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const arbitrIasClientId = getRequired('VITE_ARBITR_IAS_CLIENT_ID' as any);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const arbitrIasBffBasePath = getRequired('VITE_ARBITR_IAS_BFF_BASE_PATH' as any);
export const authEnabled = get('VITE_APP_AUTH_ENABLED', 'false') === 'true';
